import React, {FC, useCallback, useEffect, useMemo, useState} from 'react'
import {DateRangePicker} from 'rsuite'
import 'rsuite/DateRangePicker/styles/index.css'
import addDays from 'date-fns/addDays'
import subDays from 'date-fns/subDays'
import startOfMonth from 'date-fns/startOfMonth'
import addMonths from 'date-fns/addMonths'
import endOfMonth from 'date-fns/endOfMonth'
import {RangeType} from 'rsuite/DatePicker'
import {UserInterface} from '../../modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {DateRangeType} from '../../../global'
import {DateRangeInterface} from '../types'
import {useSpring, animated} from '@react-spring/web'
import './date-range.scss'
import {UseWindowSize} from '../../features/hooks/UseWindowSize'
import {DEFAULT_DATE_RANGE} from '../../@types/global'

const DATE_RANGE: FC<DateRangeInterface> = ({onDateRangeChange, loading, setLoading}) => {

    const {created_at} = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface
    const [rangeValue, setRangeValue] = useState<DateRangeType>(DEFAULT_DATE_RANGE)
    const {width} = UseWindowSize()

    // const {created_at} = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface
    // const [rangeValue, setRangeValue] = useState<DateRangeType>(DEFAULT_DATE_RANGE)

    const handleDateChange = useCallback(
        (value: DateRangeType) => {
            setRangeValue(value)
            onDateRangeChange(value)
            setLoading('pending')
        },
        [onDateRangeChange, setLoading],
    )

    useEffect(() => {
        if (loading === 'fulfilled') {
            const timer = setTimeout(() => setLoading('idle'), 500)
            return () => clearTimeout(timer)
        }
    }, [loading, setLoading])


    const ranges = useMemo(() => {
        const today = new Date()
        return [
            {label: 'Tous', value: [new Date(`${created_at}`), today]},
            {label: 'Aujourd\'hui', value: [today, today]},
            {label: 'Hier', value: [addDays(today, -1), addDays(today, -1)]},
            {label: '7 derniers jours', value: [subDays(today, 6), today]},
            {label: '30 derniers jours', value: [subDays(today, 29), today]},
            {label: 'Ce mois-ci', value: [startOfMonth(today), today]},
            {label: 'Mois dernier', value: [startOfMonth(addMonths(today, -1)), endOfMonth(addMonths(today, -1))]},
            {label: 'Cette année', value: [new Date(today.getFullYear(), 0, 1), today]},
        ] as RangeType<any>[]
    }, [created_at])

    const springs = useSpring({
        opacity: loading === 'pending' ? 1 : 0,
        transform: loading !== 'pending' ? 'translateX(20px)' : 'translateX(0px)',
        config: { tension: 170, friction: 26 },
    });

    return (
        <>

            <animated.div style={springs} className="px-1 fs-8">
                <span className="" data-kt-indicator="on">
                    <span className="indicator-progress p-2">
                        <span className="spinner-border text-info spinner-border-sm align-middle" />
                    </span>
                </span>
            </animated.div>

            <DateRangePicker ranges={ranges}
                             placement={'bottomEnd'}
                             format="dd/MM/yyyy"
                             placeholder="jj/mm/aaaa ~ jj/mm/aaaa"
                             value={rangeValue}
                             onChange={handleDateChange}
                             onOk={handleDateChange}
                             size="sm"
                             showOneCalendar={width < 576}
            />
        </>
    )
}

export {DATE_RANGE}
